module.exports = __webpack_public_path__ + "img/aqitai.b7eccbd8.svg";